import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  imagePickerContainer: {
    width: "100%",
    display: "flex",
    flexFlow: "column wrap",
  },
  imagePickerAndPreviewContainer: {
    width: "100%",
    marginTop: 10,
    display: "flex",
    flexFlow: "row wrap",
  },
  preview: {
    aspectRatio: "16/9",
    height: "140px",
    maxHeight: 200,
    maxWidth: 400,
    objectFit: "contain",
    marginTop: 2,
  },
  field: {
    width: 220,
  },
  bodyContainer: {
    display: "flex",
    marginTop: 10,
    gap: 8,
    alignItems: "flex-end",
  },
  fieldBody: {
    minWidth: 120,
    width: 445,
  },
  firstFormContainer: {
    display: "flex",
    flexFlow: "row wrap",
    gap: 4,
    margin: "0px 0px 10px 0px",
  },
}));

export default useStyles;
